// Auto-generated from products.csv
export const productsData = [
  {
    "id": "1",
    "sku": "15031",
    "notes": "未包被 8 联排管，适用于比色检测"
  },
  {
    "id": "2",
    "sku": "15042",
    "notes": "未包被 96 孔板，适用于化学发光检测"
  },
  {
    "id": "3",
    "sku": "15100",
    "notes": "透明的 8 联排管，适用于在酸酐活化板上结合胺官能团"
  },
  {
    "id": "4",
    "sku": "15110",
    "notes": "透明的 96 孔板，适用于在酸酐活化板上结合胺官能团"
  },
  {
    "id": "5",
    "sku": "15116",
    "notes": "样品中具有高丰度的目标分析物时，NeutrAvidin 预包被的板能够最大程度地减少背景噪声"
  },
  {
    "id": "6",
    "sku": "15117",
    "notes": "样品中具有高丰度的目标分析物时，NeutrAvidin 预包被的板能够最大程度地减少背景噪声"
  },
  {
    "id": "7",
    "sku": "15118",
    "notes": "化学发光检测中，可以使用白色板结合生物素化检测抗体"
  },
  {
    "id": "8",
    "sku": "15119",
    "notes": "荧光检测中，可以使用黑色板结合生物素化检测抗体"
  },
  {
    "id": "9",
    "sku": "15120",
    "notes": "比色检测中，可以使用 8 联排管结合生物素化检测抗体"
  },
  {
    "id": "10",
    "sku": "15147",
    "notes": "经过铜预处理的白色板，适用于化学发光检测"
  },
  {
    "id": "11",
    "sku": "15148",
    "notes": "经过铜预处理的黑色板，适用于荧光检测"
  },
  {
    "id": "12",
    "sku": "15152",
    "notes": "化学发光检测中，可以使用白色板结合巯基官能团"
  },
  {
    "id": "13",
    "sku": "15153",
    "notes": "荧光检测中，可以使用黑色板结合巯基官能团"
  },
  {
    "id": "14",
    "sku": "15240",
    "notes": "化学发光检测中，可以使用白色板结合 GST 标记抗体"
  },
  {
    "id": "15",
    "sku": "15242",
    "notes": "经过镍预处理的白色板，适用于化学发光检测"
  },
  {
    "id": "16",
    "sku": "15401",
    "notes": "样品中具有高丰度的目标分析物时，NeutrAvidin 预包被的板能够最大程度地减少背景噪声"
  },
  {
    "id": "17",
    "sku": "15505",
    "notes": "化学发光检测中，可以使用 384 孔白色板结合生物素化检测抗体"
  },
  {
    "id": "18",
    "sku": "15041",
    "notes": "未包被 96 孔板，适用于比色检测"
  },
  {
    "id": "19",
    "sku": "15124",
    "notes": "比色检测中，可以使用 96 孔透明板结合生物素化检测抗体"
  },
  {
    "id": "20",
    "sku": "15127",
    "notes": "样品中具有高丰度的目标分析物时，NeutrAvidin 预包被的板能够最大程度地减少背景噪声"
  },
  {
    "id": "21",
    "sku": "15129",
    "notes": "样品中具有高丰度的目标分析物时，NeutrAvidin 预包被的板能够最大程度地减少背景噪声"
  },
  {
    "id": "22",
    "sku": "15134",
    "notes": "比色检测中，可以使用透明板结合山羊抗小鼠 IgG"
  },
  {
    "id": "23",
    "sku": "15140",
    "notes": "比色检测中，可以使用透明板结合 GST 标记抗体"
  },
  {
    "id": "24",
    "sku": "15142",
    "notes": "经过镍预包被的透明板，适用于比色检测"
  },
  {
    "id": "25",
    "sku": "15143",
    "notes": "经过铜预包被的透明板，适用于比色检测"
  },
  {
    "id": "26",
    "sku": "15146",
    "notes": "经过铜预包被的透明 8 联排管，适用于比色检测"
  },
  {
    "id": "27",
    "sku": "15150",
    "notes": "比色检测中，可以使用透明板结合巯基官能团"
  },
  {
    "id": "28",
    "sku": "15340",
    "notes": "荧光检测中，可以使用黑色板结合 GST 标记抗体"
  },
  {
    "id": "29",
    "sku": "15342",
    "notes": "经过镍预包被的黑色板，适用于荧光检测"
  },
  {
    "id": "30",
    "sku": "15400",
    "notes": "样品中具有高丰度的目标分析物时，NeutrAvidin 预包被的板能够最大程度地减少背景噪声"
  },
  {
    "id": "31",
    "sku": "15402",
    "notes": "样品中具有高丰度的目标分析物时，NeutrAvidin 预包被的板能够最大程度地减少背景噪声"
  },
  {
    "id": "32",
    "sku": "15405",
    "notes": "比色检测中，可以使用 384 孔透明板结合生物素化检测抗体"
  },
  {
    "id": "33",
    "sku": "15407",
    "notes": "荧光检测中，可以使用 384 孔黑色板结合生物素化检测抗体"
  },
  {
    "id": "34",
    "sku": "15442",
    "notes": "经过镍预包被的板，适用于比色检测"
  },
  {
    "id": "35",
    "sku": "15500",
    "notes": "高容量板，专用于提高低丰度分析物的信号灵敏度"
  },
  {
    "id": "36",
    "sku": "15501",
    "notes": "高容量板，专用于提高低丰度分析物的信号灵敏度"
  },
  {
    "id": "37",
    "sku": "15502",
    "notes": "高容量板，专用于提高低丰度分析物的信号灵敏度"
  },
  {
    "id": "38",
    "sku": "15503",
    "notes": "高容量板，专用于提高低丰度分析物的信号灵敏度"
  },
  {
    "id": "39",
    "sku": "15504",
    "notes": "高容量板，专用于提高低丰度分析物的信号灵敏度"
  },
  {
    "id": "40",
    "sku": "15506",
    "notes": "高容量板，专用于提高低丰度分析物的信号灵敏度"
  },
  {
    "id": "41",
    "sku": "15525",
    "notes": "荧光检测中，可以使用黑色 8 联排管结合生物素化检测抗体"
  },
  {
    "id": "42",
    "sku": "437111",
    "notes": "未包被 96 孔黑色板，适用于荧光检测"
  },
  {
    "id": "43",
    "sku": "446471",
    "notes": "未包被黑色 8 联排管，适用于荧光检测"
  },
  {
    "id": "44",
    "sku": "460372",
    "notes": "未包被 384 孔白色板，适用于化学发光检测"
  },
  {
    "id": "45",
    "sku": "460518",
    "notes": "未包被 384 孔黑色板，适用于荧光检测"
  },
  {
    "id": "46",
    "sku": "463201",
    "notes": "未包被白色 8 联排管，适用于化学发光检测"
  },
  {
    "id": "47",
    "sku": "464718",
    "notes": "未包被 384 孔透明板，适用于比色检测"
  },
  {
    "id": "48",
    "sku": "28360",
    "notes": "兼容 HRP 酶和 AP 酶"
  },
  {
    "id": "49",
    "sku": "37535",
    "notes": "高性能封闭缓冲液，适用于未包被板"
  },
  {
    "id": "50",
    "sku": "21130",
    "notes": "HRP-偶联链霉亲和素可放大生物素化检测抗体的信号值"
  },
  {
    "id": "51",
    "sku": "21140",
    "notes": "Poly-HRP 链霉亲和素可以最大程度放大低丰度分析物的信号灵敏度"
  },
  {
    "id": "52",
    "sku": "S921",
    "notes": "AP-偶联链霉亲和素可放大生物素化检测抗体的信号值"
  },
  {
    "id": "53",
    "sku": "15169",
    "notes": "HRP 活化荧光底物"
  },
  {
    "id": "54",
    "sku": "34022",
    "notes": "HRP 活化比色底物"
  },
  {
    "id": "55",
    "sku": "34024",
    "notes": "TMB 底物的化学反应缓慢，可避免高丰度分析物出现信号饱和的问题"
  },
  {
    "id": "56",
    "sku": "34028",
    "notes": "TMB 底物可以放大低丰度分析物的信号灵敏度"
  },
  {
    "id": "57",
    "sku": "37070",
    "notes": "HRP 活化化学发光底物"
  },
  {
    "id": "58",
    "sku": "37075",
    "notes": "可放大低丰度分析物的信号灵敏度"
  },
  {
    "id": "59",
    "sku": "37621",
    "notes": "AP 活化比色底物"
  },
  {
    "id": "60",
    "sku": "T2214",
    "notes": "AP 活化化学发光底物"
  },
  {
    "id": "61",
    "sku": "T2216",
    "notes": "可放大低丰度分析物的信号灵敏度"
  },
  {
    "id": "62",
    "sku": "N600",
    "notes": "终止液可终止 TMB 底物的化学反应"
  },
  {
    "id": "63",
    "sku": "15075",
    "notes": "方便的规格，适用于多通道移液器"
  },
  {
    "id": "64",
    "sku": "15036",
    "notes": "可在孵育期间保护板"
  },
  {
    "id": "65",
    "sku": "n/a",
    "notes": "None"
  },
  {
    "id": "66",
    "sku": "n/a",
    "notes": "None"
  },
  {
    "id": "67",
    "sku": "28382",
    "notes": "None"
  },
  {
    "id": "68",
    "sku": "37520",
    "notes": "None"
  },
  {
    "id": "69",
    "sku": "CB01100",
    "notes": "None"
  },
  {
    "id": "70",
    "sku": "CNB0011",
    "notes": "None"
  },
  {
    "id": "71",
    "sku": "28348",
    "notes": "None"
  },
  {
    "id": "72",
    "sku": "28358",
    "notes": "None"
  },
  {
    "id": "73",
    "sku": "37570",
    "notes": "None"
  }
];
